module.exports = __webpack_public_path__ + "img/apostle_logo.722d97fb.png";